module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectGuards":"Select Guards","selectGuardsHint":"Select the guards you want to protect this transition"},"fr":{"selectGuards":"Choisir les gardes","selectGuardsHint":"Choisissez les gardes qui protègent cette transition"}}')
  delete Component.options._Ctor
}
